const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86400;
const PAD_LENGTH = 2;
const TICK_INTERVAL_MS = 1000;
const DAYS_DISPLAY_CAP = 100;

const pad = (n) => String(n).padStart(PAD_LENGTH, '0');
const padDays = (n) => (n < DAYS_DISPLAY_CAP ? pad(n) : String(n));

const tick = (el, targetMs) => {
  const diff = targetMs - Date.now();

  if (diff <= 0) {
    const expiredHtml = el.dataset.countdownExpired || '';
    const textEl = el.querySelector('[data-countdown-text]');
    const timerEl = el.querySelector('[data-countdown-timer]');
    if (textEl) textEl.innerHTML = expiredHtml;
    if (timerEl) timerEl.remove();
    return true;
  }

  const totalSeconds = Math.floor(diff / MS_PER_SECOND);
  const units = {
    days: padDays(Math.floor(totalSeconds / SECONDS_PER_DAY)),
    hours: pad(Math.floor((totalSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR)),
    minutes: pad(Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)),
    seconds: pad(totalSeconds % SECONDS_PER_MINUTE),
  };

  for (const [name, value] of Object.entries(units)) {
    const unitEl = el.querySelector(`[data-countdown-${name}]`);
    if (unitEl) unitEl.textContent = value;
  }

  return false;
};

const initCountdown = (el) => {
  const targetMs = Number(el.dataset.countdownEndMs);
  if (!Number.isFinite(targetMs) || targetMs <= 0) return;

  const done = tick(el, targetMs);
  if (done) return;

  el.dataset.countdownInitialized = 'true';

  const intervalId = setInterval(() => {
    if (!el.isConnected) {
      clearInterval(intervalId);
      return;
    }
    const expired = tick(el, targetMs);
    if (expired) clearInterval(intervalId);
  }, TICK_INTERVAL_MS);
};

const initAnnouncementCountdown = () => {
  const els = document.querySelectorAll('[data-countdown]:not([data-countdown-initialized])');
  els.forEach(initCountdown);
};

export default initAnnouncementCountdown;
